import React from "react";
import { baseUrl } from "../../../../../config/config";
import TippyCopy from "../../../../../revampComponents/Atom/TippyCopy";
import { dashboardColors, theme } from "../../../../../themes/Theme";

const LinkedInAuthorization = () => {
    return (
        <div className="linkedin-authorization mt-4">
            <div className="linkedin-instructions-title">Authorization URL</div>
            <p>Copy the Authorization Redirect URL and add it to your app.</p>
            <div className="custom-mixUrlField w-100 d-inline-flex">
                <p className="custom-icon-in-input w-100 m-0">
                    <input
                        type="text"
                        className="input w-100"
                        value={`${baseUrl}/linkedin-share`}
                        readOnly
                        disabled
                    />
                    <TippyCopy
                        className="col-2 custom-input-icon"
                        content={`${baseUrl}/linkedin-share`}
                        iconStyle={{ color: dashboardColors[theme].primary, }}
                    />
                </p>
            </div>
        </div>
    );
};

export default LinkedInAuthorization;
